import React from "react";
import "./PricingModal.css";

export default function PricingModal({ isOpen, onClose, clientRefId, customerEmail }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>✕</button>

        {/* Stripe Pricing Table embed */}
        <stripe-pricing-table
          pricing-table-id="prctbl_1S6ES8CagDAeI1bFDt9xPpWO"
          publishable-key="pk_live_qjv7ksQqFLGV5T3oYoff4oQW"
          client-reference-id={clientRefId}
          customer-email={customerEmail}
        >
        </stripe-pricing-table>
      </div>
      {/* The script tag must be outside of React’s virtual DOM */}
      <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
    </div>
  );
}
